export default __webpack_public_path__ + "static/media/vertical_triple_dot.bbd42156.svg";